import { cx } from "@emotion/css";
import { ReactNode } from "react";

import { Link } from "@/modules/theme/components/Link/Link";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { createButtonStyles } from "@/modules/theme/utils/createButtonStyles";
import { ButtonVariants } from "@/modules/theme/utils/types";

import { createButtonLinkStyles } from "./helpers/createButtonLinkStyles";

export interface ButtonLinkProps {
  className?: string;
  to: string;
  children: ReactNode;
  isDisabled?: boolean;
  title?: string;
  variant?: ButtonVariants;
  source?: "Internal" | "External";
  onClick?: () => void;
}

export const ButtonLink = ({
  to,
  className,
  children,
  isDisabled,
  title,
  onClick,
  variant = "primary",
  source = "Internal",
}: ButtonLinkProps) => {
  const theme = useTheme();
  const classes = createButtonLinkStyles();
  const buttonClasses = createButtonStyles(theme);

  const LinkElement = Link[source];
  return (
    <LinkElement
      disabled={isDisabled}
      className={cx(
        buttonClasses.root,
        classes.root,
        buttonClasses[variant],
        className,
        {
          [buttonClasses.disabled]: isDisabled,
        }
      )}
      onClick={onClick}
      to={to}
      title={title}
    >
      {children}
    </LinkElement>
  );
};
